<template>
    <div :class="'ext-input form-group col-'+col+' '+form_class">
    <input
    :id="input_id"
    :type="formtype"
    :class="'form-control '+ input_class"
    :value="modelValue"
    :max="max"
    :placeholder="placeholder"

    @input="$event => $emit('update:modelValue', $event.target.value)"
    :disabled="disabled"
    :list="listname"
    >
    <label :for="input_id">{{ label }}</label>

  <datalist :id="listname">
  <option v-for="(item, index) in list" :value="item.kelime" :key="index">{{item.kelime}}</option>
</datalist>
    </div>

</template>

<script>
export default {
  name: 'InputText',
  props: {
    form_class: String,
    input_id: String,
    listname: String,
    input_class: String,
    label: String,
    list:[Array,String,Number],
    col: String,
    formtype: String,
    min: Number,
    max: Number,
    placeholder: String,
    someEvent: String,
    modelValue: [String,Number],
    disabled:[String,Number]
  }
}
</script>

<style lang="css">

.ext-input {
  position: relative;
  z-index: auto;
}
.ext-input label{
position: absolute;
z-index: +1;
top: -12px;
left: 20px;
font-weight: 700;
background-color:var(--app-background) ;
padding: 0px 6px;
font-size: 0.98rem;
color: var(--tema-yazi) !important;
text-transform:uppercase;
}

.ext-input input{
height: 48px !important;
background-color: var(--app-background) !important;
color:var(--tema-renk01) !important;
font-weight: 400 !important;
font-size: 1.2rem !important;

}

.ext-input input:disabled{

background-color: rgb(230, 230, 230)!important;

}

.ext-input .baslik{
font-size: 2rem !important;
font-weight: 700 !important;
}

</style>
